module.exports = __webpack_public_path__ + "img/arrow_right_new.5ec73afe.png";